import React from "react";
import Skeleton from "../../Common/Skeleton";

const AllTransactionsFiltersSkeleton = () => {
  return (
    <div className="space-y-10 mt-14">
      <Skeleton className="rounded-full h-6 w-32" />
      <div className="flex flex-col space-y-10 pb-12 pr-10">
        <Skeleton className="flex w-full items-center justify-between p-2 rounded-xl">
          <div className="flex items-center">
            <Skeleton className="rounded-full h-10 w-10 mx-2" />
            <span className="flex flex-col space-y-1">
              <Skeleton className="rounded-full w-[146px] h-[16px]" />
              <Skeleton className="rounded-full w-[235px] h-[16px]" />
            </span>
          </div>
          <Skeleton className="rounded-full w-5 h-5" />
        </Skeleton>
        {[1, 2].map((item) => (
          <div key={item} className="space-y-3">
            <Skeleton className="rounded-full w-32 h-5" />
            <div className="flex items-center justify-between space-x-4">
              <Skeleton className="rounded-full w-full h-8" />
              <Skeleton className="rounded-full w-full h-8" />
              <Skeleton className="rounded-full w-full h-8" />
            </div>
          </div>
        ))}

        <div className="space-y-3">
          <Skeleton className="rounded-full w-32 h-5" />
          <div className="flex flex-col items-center justify-between space-y-4">
            <Skeleton className="rounded-xl w-full h-12" />
            <Skeleton className="rounded-xl w-full h-12" />
          </div>
          <div className="flex flex-col">
            <Skeleton className="rounded-full w-32 h-12 self-end" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllTransactionsFiltersSkeleton;
